import { render, staticRenderFns } from "./NavBarMenu.vue?vue&type=template&id=122a714f"
import script from "./NavBarMenu.vue?vue&type=script&lang=js"
export * from "./NavBarMenu.vue?vue&type=script&lang=js"
import style0 from "./NavBarMenu.vue?vue&type=style&index=0&id=122a714f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports